<template>
  <v-app id="inspire">
    <!-- <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      :right="isRight"
    >
      <v-list>
        <sidebar-item
          v-for="(route, index) in permission_routers"
          :key="route.path + index"
          :item="route"
          :base-path="route.path"
        ></sidebar-item>
      </v-list>
    </v-navigation-drawer>-->
    <!-- {{ permissions }} -->
    <v-navigation-drawer v-model="drawer" fixed temporary>
      <v-list-item>
        <img
          :src="require('@/assets/imgs/logo.png')"
          fluid
          height="60px"
          class="mx-auto my-10"
        />
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <template v-for="item in items">
          <v-list-item
            v-if="permissions.includes(item.has_permission)"
            :key="item.title"
            :to="item.link"
            link
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="drawer2"
      temporary
      fixed
      color="primary"
      dark
      right
    >
      <v-list dense class="work-list">
        <template v-for="link in links">
          <v-list-item
            v-if="permissions.includes(link.has_permission)"
            :key="link.index"
            :to="link.route"
          >
            <v-list-item-content>
              <v-list-item-title>{{ link.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app>
      <v-toolbar-title class="ml-0 pl-4">
        <v-img
          :src="require('@/assets/imgs/logo.png')"
          width="120px"
          fluid
        ></v-img>
      </v-toolbar-title>
      <v-btn
        class="hidden-sm"
        icon
        large
        @click.stop="drawer = !drawer"
        title="menu"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <div class="flex-grow-1"></div>
      <template v-for="item in items">
        <router-link
          v-if="permissions.includes(item.has_permission)"
          :key="item.title"
          :to="item.link"
          class="mx-4 toolbar-links"
          >{{ item.title }}</router-link
        ></template
      >
      <template v-for="link in hr">
        <template v-if="link.menuLinks.length != 0">
          <v-menu :key="link.title" v-if="link.menuLinks.length > 0" offset-y>
            <template v-slot:activator="{ on, toggle }">
              <v-btn
                v-on="on"
                text
                class="text-capitalize size-1"
                color="primary"
                v-if="link.menuLinks.length > 0"
              >
                {{ link.title }}
                <v-icon>{{ toggle ? "mdi-menu-up" : "mdi-menu-down" }}</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <template v-for="menuLink in link.menuLinks">
                <v-list-item
                  :key="menuLink.title"
                  :to="menuLink.to"
                  router
                  exact
                  active-class="primary--text"
                  v-if="permissions.includes(menuLink.has_permission)"
                >
                  <v-list-item-title>{{ menuLink.title }}</v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </template>
      </template>

      <template v-if="scmContainsAuthorizedRoutes">
        <v-menu offset-y>
          <template v-slot:activator="{ on, toggle }">
            <v-btn
              text
              color="primary"
              class="text-capitalize size-1"
              v-on="on"
            >
              {{ scmRoutesData.title }}
              <v-icon>{{ toggle ? "mdi-menu-up" : "mdi-menu-down" }}</v-icon>
            </v-btn>
          </template>

          <v-list dense>
            <template v-for="menuLink in scmRoutesData.menuLinks">
              <v-list-item
                :key="menuLink.title"
                :to="menuLink.to"
                router
                exact
                active-class="primary--text"
                v-if="permissions.includes(menuLink.has_permission)"
              >
                <v-list-item-title>{{ menuLink.title }}</v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>

      <template v-for="link in reports">
        <template v-if="link.menuLinks.length > 0">
          <v-menu
            :key="link.title"
            v-if="link.menuLinks && link.menuLinks.length > 0"
            offset-y
            max-height="530px"
          >
            <template v-slot:activator="{ on, toggle }">
              <v-btn
                v-on="on"
                text
                class="text-capitalize size-1"
                color="primary"
                v-if="link.menuLinks.length > 0"
              >
                {{ link.title }}
                <v-icon>{{ toggle ? "mdi-menu-up" : "mdi-menu-down" }}</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <template v-for="menuLink in link.menuLinks">
                <v-list-item
                  :key="menuLink.title"
                  :to="menuLink.to"
                  router
                  exact
                  active-class="primary--text"
                  v-if="permissions.includes(menuLink.has_permission)"
                >
                  <v-list-item-title>{{ menuLink.title }}</v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </template>
      </template>
      <template v-if="topNav.length > 0">
        <template v-for="link in topNav">
          <v-menu
            :key="link.title"
            v-if="link.menuLinks && link.menuLinks.length > 0"
            offset-y
          >
            <template v-slot:activator="{ on, toggle }">
              <v-btn
                v-on="on"
                text
                class="text-capitalize size-1"
                color="primary"
                v-if="permissions.includes('index_api_admin-panel_camp-types')"
              >
                {{ link.title }}
                <v-icon>{{ toggle ? "mdi-menu-up" : "mdi-menu-down" }}</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <template v-for="menuLink in link.menuLinks">
                <v-list-item
                  v-if="permissions.includes(menuLink.has_permission)"
                  :key="menuLink.title"
                  :to="menuLink.to"
                  router
                  exact
                  active-class="primary--text"
                >
                  <v-list-item-title>{{ menuLink.title }}</v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </template>
      </template>
      <div class="flex-grow-1"></div>
      <v-btn icon @click.stop="drawer2 = !drawer2">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <v-btn icon large @click="logout" title="logout">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-content>
      <!-- <v-container fluid> -->
      <router-view></router-view>
      <!-- </v-container> -->
    </v-content>
  </v-app>
</template>

<script>
import cookie from "js-cookie";
import { mapGetters } from "vuex";
export default {
  props: {
    source: String,
  },
  components: {
    // SidebarItem
  },
  computed: {
    ...mapGetters({
      permissions: "permissions",
    }),
    isRight() {
      if (cookie.get("language") === "ar") {
        return true;
      } else {
        return false;
      }
    },
    scmContainsAuthorizedRoutes() {
      return this.scmRoutesData.menuLinks.some((menuLink) =>
        this.permissions.includes(menuLink.has_permission)
      );
    },
    reports() {
      return [
        {
          title: "Reports",
          menuLinks: [
            {
              title: "Daily Figures",
              to: "/reports/daily-figures?available=yes",
              has_permission:
                "index_api_admin-panel_reports_camp-statistics-per-day",
            },
            {
              title: "Indiviual Reports",
              to: "/reports/individual",
              has_permission: "index_api_admin-panel_reports_individual",
            },
            {
              title: "Family Reports",
              to: "/reports/family",
              has_permission: "index_api_admin-panel_reports_family",
            },
            {
              title: "Finance Reports",
              to: "/reports/finance",
              has_permission: "index_api_admin-panel_reports_finance",
            },
            {
              title: "Receipts Reports",
              to: "/reports/receipts",
              has_permission: "index_api_admin-panel_reports_receipts",
            },
            {
              title: "Teams Reports",
              to: "/reports/teams",
              has_permission: "index_api_admin-panel_reports_teams",
            },
            {
              title: "Camp Majors Reports",
              to: "/reports/majors",
              has_permission: "index_api_admin-panel_reports_camp-majors",
            },
            {
              title: "Counselor Reports",
              to: "/reports/counselor",
              has_permission:
                "conselorReport_api_admin-panel_reports_conselor-report",
            },
            {
              title: "Director Reports",
              to: "/reports/director",
              has_permission:
                "directorReport_api_admin-panel_reports_director-report",
            },
            {
              title: "Bus Reports",
              to: "/reports/bus",
              has_permission: "busReport_api_admin-panel_reports_bus-report",
            },
            {
              title: "CRM Agents Reports",
              to: "/reports/crm/agents",
              has_permission: "index_api_admin-panel_reports_crm-agents-report",
            },
            {
              title: "CRM Interactions Reports",
              to: "/reports/crm/interactions",
              has_permission:
                "index_api_admin-panel_reports_crm-interactions-report",
            },
            {
              title: "CRM Tasks Reports",
              to: "/reports/crm/tasks",
              has_permission: "index_api_admin-panel_reports_crm-tasks-report",
            },
            {
              title: "Sales & KPIs",
              to: "/reports/sales-and-kpis",
              has_permission: "index_api_admin-panel_dashboard_crm-kpis",
            },
            {
              title: "Statistics Dashboard",
              to: "/reports/charts",
              has_permission: "index_api_admin-panel_reports_crm-tasks-report",
            },
            {
              title: this.$t("on_hand_reports"),
              to: "/reports/on-hand-reports",
              has_permission: "index_api_admin-panel_reports_abroad",
            },
            {
              title: this.$t("item-control"),
              to: "/reports/item-control",
              has_permission: "index_api_admin-panel_reports_item-control",
            },
            {
              title: this.$t("item-card"),
              to: "/reports/item-card",
              has_permission: "index_api_admin-panel_reports_item-card",
            },
          ],
        },
      ];
    },
  },
  data: () => ({
    dialog: false,
    drawer2: null,
    drawer: false,
    group: null,
    topNav: [
      {
        title: "Content",
        menuLinks: [
          {
            title: "Camp Types",
            to: "/camp-types",
            has_permission: "index_api_admin-panel_camp-types",
          },
          {
            title: "News",
            to: "/content/news",
            has_permission: "index_api_admin-panel_content_newsletters",
          },
          {
            title: "FAQs",
            to: "/content/faqs",
            has_permission: "index_api_admin-panel_content_faqs",
          },
          {
            title: "Discounts - Categories",
            to: "/content/discounts-categories",
            has_permission: "index_api_admin-panel_content_discount-categories",
          },
          {
            title: "Familia",
            to: "/content/familia-episodes",
            has_permission: "index_api_admin-panel_content_familia-episodes",
          },
          {
            title: "CSR",
            to: "/content/csr",
            has_permission: "index_api_admin-panel_content_csrs",
          },
          {
            title: "Online Courses",
            to: "/content/online-courses",
            has_permission: "index_api_admin-panel_content_online-courses",
          },
          {
            title: "Sponsors",
            to: "/content/sponsors",
            has_permission: "index_api_admin-panel_content_newsletters",
          },
          {
            title: "Testimonials",
            to: "/content/testimonials",
            has_permission: "index_api_admin-panel_content_newsletters",
          },
          // {
          //   title: "Jobs",
          //   to: "/content/jobs",
          //   has_permission: "index_api_admin-panel_content_newsletters",
          // },
          {
            title: "Jobs ",
            to: "/content/job-categories",
            has_permission: "index_api_admin-panel_content_newsletters",
          },
          {
            title: "Notification ",
            to: "/content/notification",
            has_permission: "index_api_admin-panel_content_newsletters",
          },
        ],
      },
    ],

    hr: [
      {
        title: "HR",
        menuLinks: [
          {
            title: "Application Types",
            to: "/hr/application-types",
            has_permission: "index_api_admin-panel_hr_application-types",
          },
          {
            title: "Phases",
            to: "/hr/phases",
            has_permission: "index_api_admin-panel_hr_phases",
          },
          {
            title: "Collection Bags",
            to: "/hr/collection-bags",
            has_permission: "index_api_admin-panel_hr_collection-bags",
          },
          {
            title: "Dashboard",
            to: "/hr/dashboard",
            has_permission:
              "index_api_admin-panel_hr_dashboard_applications" ||
              "index_api_admin-panel_hr_dashboard_statistics",
          },
        ],
      },
    ],
    scmRoutesData: {
      title: "SCM",
      menuLinks: [
        {
          title: "Items",
          to: "/scm/items",
          has_permission: "index_api_admin-panel_scm_items",
        },
        {
          title: "Transactions",
          to: "/scm/transactions",
          has_permission: "index_api_admin-panel_scm_transactions",
        },
        {
          title: "On Hands",
          to: "/scm/on-hands",
          has_permission: "index_api_admin-panel_scm_on-hands",
        },
        {
          title: "Sub Inventories",
          to: "/scm/sub-inventories",
          has_permission: "index_api_admin-panel_scm_inventories",
        },
        {
          title: "Categories",
          to: "/scm/categories",
          has_permission: "index_api_admin-panel_scm_categories",
        },
        {
          title: "Transactions Types",
          to: "/scm/transactions-types",
          has_permission: "index_api_admin-panel_scm_transaction-types",
        },
        {
          title: "Camps",
          to: "/scm/camps",
          has_permission: "index_api_admin-panel_scm_camps",
        },
        {
          title: "Employees",
          to: "/scm/employees",
          has_permission: "index_api_admin-panel_scm_employees",
        },
      ],
    },
    links: [
      {
        route: "/discounts",
        name: "Discounts",
        has_permission: "index_api_admin-panel_discounts",
      },
      {
        route: "/majors",
        name: "Majors",
        has_permission: "index_api_admin-panel_majors",
      },
      {
        route: "/cashiers",
        name: "Cashiers",
        has_permission: "index_api_admin-panel_cashiers",
      },
      {
        route: "/parameters",
        name: "Parameters & Controllers",
        has_permission: "index_api_admin-panel_parameters",
      },
      {
        route: "/employees",
        name: "Employees",
        has_permission: "index_api_admin-panel_employees",
      },
      // {
      //   route: "/employees/discounts",
      //   name: "Employee Discounts",
      //   has_permission: "index_api_admin-panel_employee-discounts"
      // },
      {
        route: "/bus-locations",
        name: "Bus Locations",
        has_permission: "index_api_admin-panel_bus-locations",
      },
      {
        route: "/bus-stops",
        name: "Bus stops",
        has_permission: "index_api_admin-panel_bus-stops",
      },
      {
        route: "/camp-locations",
        name: "Camp Locations",
        has_permission: "index_api_admin-panel_bus-locations",
      },
      {
        route: "/list/promocodes",
        name: "Promocodes",
        has_permission: "index_api_admin-panel_promo-codes",
      },
    ],

    items: [
      {
        title: "Camps",
        link: "/camps",
        has_permission: "index_api_admin-panel_camps",
      },
      {
        title: "Bookings",
        link: "/bookings",
        has_permission:
          "index_api_admin-panel_orders_{camp_id?}_{status?}_{gender?}_{month?}_{year?}",
      },
      {
        title: "CRM",
        link: "/crm/WorkList",
        has_permission: "index_api_admin-panel_crm_actions",
      },
      {
        title: "Parents",
        link: "/accounts",
        has_permission: "index_api_admin-panel_accounts",
      },
      {
        title: "Children",
        link: "/children",
        has_permission: "index_api_admin-panel_children",
      },
    ],
  }),
  methods: {
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // In order to re-instantiate the vue-router object to avoid bugs
      });
    },
  },
};
</script>
